<script setup lang="ts">
    import { InputRow, Combobox } from '@/components/ui/form';
    import { useEconomicProjectData } from '@/composables/useEconomicProjectData';
    import { watch } from 'vue';

    const props = defineProps<{
        form: any;
        companyId: number;
    }>();

    const { projects, isPlaceholderDataProjects } = useEconomicProjectData(props.companyId);

    watch(
        () => projects.value,
        (newProjects) => {
            props.form.projects = newProjects;
        },
        { immediate: true },
    );
</script>

<template>
    <div class="flex flex-col gap-3">
        <InputRow
            :form="form"
            name="project_id"
            label="vouchers.select.project_confirm.project"
        >
            <Combobox
                v-model="form.project_id"
                :options="projects"
                label-by="name"
                value-by="number"
                :loading="isPlaceholderDataProjects"
            />
        </InputRow>
    </div>
</template>
